import React, {useState} from "react";
import {Badge, Divider, Popover} from "antd";
import { Icon } from '@ant-design/compatible';
import {BellOutlined} from "@ant-design/icons";

export default function Notifications({ notifications, onMarkAllAsRead, onNotificationClick }) {
  const [isVisible, setIsVisible] = useState(false)

  const NotificationCard = ({ notification: data, onNotificationClick }) => {
    return (
      <div
        onClick={() => onNotificationClick(data)}
        className="notification-card"
      >
        <div>
          <Icon type={data.icon} />
          <b style={{ paddingLeft: 5 }}>{data.title}</b>
        </div>
        <span>{data.description}</span>
        <Divider className="notification-divider" />
      </div>
    )
  }

  const NotificationContent = ({ notifications, onMarkAllAsRead, onNotificationClick }) => {
    // TODO: ver se precisa disso! (caso sim, ver um jeito de não precisar! - filtrar no firebase, jogar pro componente apenas as notificações novas já ordenadas...)
    const filteredAndSortedNotifications = notifications.filter(x => x.read !== true).sort((a, b) => b.date - a.date);

    return (
      <div className="notification-content">
        {filteredAndSortedNotifications.map((notification, index) =>
          <NotificationCard onNotificationClick={onNotificationClick} key={index} notification={notification} />)}
        {notifications.length > 0 ? (
          <span className="read-all" onClick={onMarkAllAsRead}>Marcar todas as notificações como lida</span>
        ) : (
          <div className="notification-empty-state">
            <BellOutlined className="empty-bell-icon" />
            <p className="empty-text">Não existe nenhum notificação nesse momento</p>
          </div>
        )}
      </div>
    )
  }

  const hideNotification = () => setIsVisible(false)

  const handleMarkAllAsRead = () => {
    hideNotification()
    onMarkAllAsRead()
  }

  const handleNotificationClick = data => {
    hideNotification()
    onNotificationClick(data)
  }

  return (
    <div className="notification-container">
      <Popover
        content={
          <NotificationContent
            onNotificationClick={handleNotificationClick}
            onMarkAllAsRead={handleMarkAllAsRead}
            notifications={notifications} />
        }
        title="Notificações"
        trigger="click"
        visible={isVisible}
        onVisibleChange={isVisible => setIsVisible(isVisible)}
      >
        <Badge count={notifications.length}>
          <BellOutlined className="bell-icon" />
        </Badge>
      </Popover>
    </div>
  )
}
